import i18n, { currentLanguage } from '@/i18n';

/**
 * Подпись причины возврата на языке интерфейса.
 *
 * Подпись — данные: менеджер может её поправить, и в русском интерфейсе она показывается
 * как есть. Системным причинам из миграции (QUALITY, SHORTAGE…) для других языков есть
 * перевод по коду; своим причинам менеджера — их подпись.
 */
export function reasonLabel(reason: { code: string; label: string }): string {
  if (currentLanguage() === 'ru') return reason.label;
  const key = `reasonCodes.${reason.code}`;
  return i18n.exists(key) ? i18n.t(key) : reason.label;
}
